import React, { useEffect, useState } from 'react';
import {
    Dialog,
    Box,
    Typography,
    IconButton,
    Stack,
    Divider,
    CardMedia,
    Button,
    Grid
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'; // Ícono para archivos genéricos
import { useDispatch } from "react-redux";
import { useParams } from 'react-router-dom';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; 
import DescriptionIcon from '@mui/icons-material/Description'; 
import TableChartIcon from '@mui/icons-material/TableChart'; 

const AttachFilesModal = ({ open, close, file }) => {
    const { id } = useParams();
    const [selectedFile, setSelectedFile] = useState(null); // Solo un archivo
    const [previewUrl, setPreviewUrl] = useState(null); // Estado para la URL de vista previa

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase(); // Extraer la extensión del archivo
    
        switch (extension) {
            case 'pdf':
                return <PictureAsPdfIcon sx={{ fontSize: 75, marginRight: 2, color: 'red' }} />; // Ícono para PDF
            case 'doc':
            case 'docx':
                return <DescriptionIcon sx={{ fontSize: 75, marginRight: 2, color: 'blue' }} />; // Ícono para Word
            case 'xls':
            case 'xlsx':
                return <TableChartIcon sx={{ fontSize: 75, marginRight: 2, color: 'green' }} />; // Ícono para Excel
            default:
                return <InsertDriveFileIcon sx={{ fontSize: 75, marginRight: 2, color: 'gray' }} />; // Ícono genérico para otros archivos
        }
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0]; // Obtener solo el primer archivo

        if (file) {
            const isImage = file.type.startsWith('image/');
            const previewUrl = isImage ? URL.createObjectURL(file) : null; // Genera la URL de vista previa solo si es una imagen

            setSelectedFile(file); // Guardar el archivo en el estado
            setPreviewUrl(previewUrl); // Guardar la URL de vista previa si es imagen
        }
    };

    const handleSubmitFiles = () => {
        if (selectedFile) {
            const formData = new FormData();
            formData.append("IdProvider", Number(id)); // Adjuntar el idRoute una vez
            formData.append("File", selectedFile); // Adjuntar el archivo seleccionado
            file(formData);
        }

        // Reseteo después de subir el archivo
        setSelectedFile(null);
        setPreviewUrl(null);
        onClose();
    };

    const onClose = () => {
        setSelectedFile(null); // Limpiar el archivo seleccionado al cerrar
        setPreviewUrl(null); // Limpiar la vista previa al cerrar
        close();
    };

    return (
        <div>
            <Dialog onClose={onClose} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                    Subir Archivo
                </Typography>
                <Divider />

                <Grid container spacing={2} sx={{ p: 2, justifyContent: 'center' }}>
                    {selectedFile && (
                        <Grid item xs={4} > 
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {previewUrl ? (
                                    // Vista previa para imágenes
                                    <CardMedia
                                    component="img"
                                    image={previewUrl}
                                    alt={`Vista previa del archivo`}
                                    sx={{  maxWidth: '100%',     // Ajusta el ancho máximo a 100% del contenedor
                                        maxHeight: 300,  objectFit: 'contain', marginRight: 2 }}
                                    />
                                ) : (
                                    // Mostrar ícono y nombre para otros archivos
                                    getFileIcon(selectedFile.name)
                                )}
                                <Typography variant="subtitle1">
                                    {selectedFile.name} {/* Muestra el nombre del archivo */}
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                        {/* Mostrar el botón de seleccionar archivo solo si no hay un archivo seleccionado */}
                        {!selectedFile && (
                            <Button variant="contained" component="label" color="primary" sx={{ width: 200 }}>
                                Seleccionar archivo
                                <input
                                    type="file"
                                    hidden
                                    onChange={handleFileUpload} 
                                />
                            </Button>
                        )}

                        {/* Mostrar el botón de subir archivo solo si hay un archivo seleccionado */}
                        {selectedFile && (
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleSubmitFiles}
                                sx={{ width: 200 }}
                            >
                                Subir archivo
                            </Button>
                        )}
                </Box>
            </Dialog>
        </div>
    );
};

export default AttachFilesModal;
